/*
'inform_practioner_new_appointment',
'appointment_confirmation_message',
'appointment_reminder',
'notify_client_reschedule',
'notify_client_cancellation'
*/
export const SECTIONS = [
  {
    id: 'greeting',
    title: 'Customer Greeting',
    selected: {
      Email: true,
      SMS: true
    },
    editable: true,
    forceedit: true,
    content: `Hi {{client.first_name}}`,
    description: 'Great your client by name',
    sms: true,
    context: [
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule',
      'notify_client_cancellation'
    ]
  },
  {
    id: 'practitionerGreeting',
    title: 'Practitioner Greeting',
    selected: {
      Email: true,
      SMS: true
    },
    content: `Hi {{me.first_name}}.`,
    sms: true,
    description: 'Great the practitioner (that\'s you) by their first name',
    context: [
      'inform_practioner_new_appointment'
    ]
  },
  {
    id: 'apptSummary',
    title: 'Intro text',
    selected: {
      Email: true,
      SMS: true
    },
    editable: true,
    sms: true,
    content: `
Your appointment with {% if me.profile.profession %}{{me.profile.profession.name}} {% endif %}{{me.get_full_name}} on {{appointment_start_date}} at {{appointment_start_time}}   `,
    description: 'A short note with a summary of the appointment',
    context: [
      'inform_practioner_new_appointment',
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule',
      'notify_client_cancellation'
    ]
  },
  {
    id: 'appointmentNotes',
    title: 'System notes',
    selected: {
      Email: true,
      SMS: false
    },
    content: `{% if appointment.notes %}

**System notes**

{{appointment.notes}}{% endif %}`,
    description: 'System notes from AppointmentGuru with information about processing the appointment',
    context: [
      'inform_practioner_new_appointment'
    ]
  },
  {
    id: 'customNote',
    title: 'Custom note',
    description: 'Add your own note to the message (you can write whatever you like)',
    selected: {
      Email: false,
      SMS: false
    },
    editable: true,
    forceedit: true,
    sms: true,
    content: '',
    context: [
      'inform_practioner_new_appointment',
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule',
      'notify_client_cancellation'
    ]
  },
  {
    id: 'apptLink',
    title: 'Link to appointment page',
    description: 'A link to the client\'s appointment page where they can view more information on their appointment',
    selected: {
      Email: false,
      SMS: true
    },
    editable: false,
    forceedit: true,
    sms: true,
    content: '\nMore @ {{appointment.client_detail_url}}',
    context: [
      'inform_practioner_new_appointment',
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule'
      // 'notify_client_cancellation'
    ]
  },
  {
    id: 'details',
    title: 'Include appointment details',
    description: 'A summary of all the important information for the appointment. AppointmentGuru will dynamically create this based on the settings on the appointment',
    selected: {
      Email: true,
      SMS: false
    },
    sms: true,
    context: [
      'inform_practioner_new_appointment',
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule',
      // 'notify_client_cancellation'
    ],
    content: `

**Appointment information:**  ` + `
{{appointment.formatted_appointment_for_client}}`
  },
  {
    id: 'spaceNotes',
    title: 'Include custom note from space (if they exist)',
    description: 'Specific notes for this space',
    selected: {
      Email: true,
      SMS: false
    },
    editable: true,
    context: [
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule'
    ],
    content: `{% if appointment.space and appointment.space.settings and appointment.space.settings.notification_instructions and appointment.space.settings.notification_instructions is not '{}' %}

{{appointment.space.settings.notification_instructions}}{% endif %}`
  },
  {
    id: 'productNotes',
    title: 'Include custom note from appointment type (if it exists)',
    description: 'Specific notes for this appointment type',
    selected: {
      Email: true,
      SMS: false
    },
    editable: true,
    context: [
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule'
    ],
    content: `

{% if appointment.product and appointment.product.notes and appointment.product.notes is not '{}' %}

{{ appointment.product.notes }}{% endif %}`
  },
  {
    id: 'locationInfo',
    title: 'Location Information',
    selected: {
      Email: true,
      SMS: false
    },
    context: [
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule'
    ],
    editable: true,
    description: 'Include important address information like map links and extra notes',
    content: `{% if appointment.address and not appointment.is_online %}  ` + `
**Find your appointment:**  ` + `
{{appointment.address.name|default:appointment.address.address|default:""}}  ` + `
* [Open in Google Maps]({{appointment.map_link}}){% endif %}`
  },
  {
    id: 'g-maps',
    title: 'Include a link to Google Maps',
    selected: {
      Email: false,
      SMS: false
    },
    sms: true,
    context: [
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule'
    ],
    content: `{% if appointment.address %}
* [Open in Google Maps]({{appointment.map_link}}){% endif %}`
  },
//   {
//     id: 'three-words',
//     title: 'Include link to what3words location',
//     description: 'what3words gives every 3m square in the world a unique address of 3 words. Use w3w help the client to navigate to the entrance of your business.',
//     selected: {
//       Email: true,
//       SMS: false
//     },
//     context: [
//       'appointment_confirmation_message',
//       'appointment_reminder',
//       'notify_client_reschedule'
//     ],
//     content: `{% if appointment.address and appointment.address.three_words %}
// * [///{{appointment.address.three_words}}](https://what3words/com/{{appointment.address.three_words}}){% endif %}`
//   },
  {
    id: 'forms',
    title: 'Include a link to a form',
    description: 'If you have an online form for clients to fill out before the session, use this to include a link in your notifications',
    selected: {
      Email: false,
      SMS: false
    },
    editable: true,
    forceedit: true,
    context: [
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule'
    ],
    content: ``
  },
  {
    id: 'bookOnline',
    title: 'Book online link',
    description: 'If online bookings are enabled, include a link to your booking form',
    selected: {
      Email: true,
      SMS: true
    },
    sms: true,
    context: [
      // 'notify_client_cancellation'
    ],
    content: `{% if appointment.practitioner and not appointment.practitioner.disable_booking_widget %}
Book your next appointment online at: https://book.appt.guru/?p={{appointment.practitioner_id}}{% endif %}`
  },
  {
    id: 'attribution',
    title: 'Include AppointmentGuru attribution',
    description: 'Add a powered by AppointmentGuru to the bottom of your notification',
    selected: {
      Email: true,
      SMS: false
    },
    sms: false,
    context: [
      'appointment_confirmation_message',
      'appointment_reminder',
      'notify_client_reschedule',
      'notify_client_cancellation'
    ],
    content: `

---
Powered by [AppointmentGuru](https://appointmentguru.co)`
  }
]
